import { render, staticRenderFns } from "./exchangeDiscount.vue?vue&type=template&id=3a20902e&scoped=true&"
import script from "./exchangeDiscount.vue?vue&type=script&lang=js&"
export * from "./exchangeDiscount.vue?vue&type=script&lang=js&"
import style0 from "./exchangeDiscount.vue?vue&type=style&index=0&id=3a20902e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20902e",
  null
  
)

export default component.exports